<template>
  <v-layout justify-center>
    <v-flex xs12 sm6 md4>
      <v-card
        id="myTrackings"
        style="max-height: calc(100vh - 60px)"
        class="overflow-y-auto"
      >
        <v-list
          two-line
          v-scroll:#myTrackings="onScroll"
        >
          <template v-for="(tracking,index) in myTrackings">
            <v-list-item
              :key="index"
            >
              <v-list-item-content>
                <v-list-item-title>{{tracking.customer.firstName}} {{tracking.customer.lastName}}</v-list-item-title>
                <v-list-item-subtitle class="hidden-xs-and-down">{{tracking.customer.street}}, {{tracking.customer.city}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{getDate(tracking.startTime)}}: {{getTime(tracking.startTime)}}-{{getTime(tracking.finishTime)}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{tracking.service.name}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text
                       icon
                       @click="openEditServiceTracking(tracking)"
                       color="primary">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn text
                       icon
                       @click="openDeleteServiceTracking(tracking)"
                       color="primary">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index + 1 < myTrackings.length"
              :key="'divider-'+index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
      <data-loader></data-loader>
      <new-tracking-dialog :show="showNewServiceTrackingDialog" @close="closeNewServiceTracking"></new-tracking-dialog>
      <edit-service-tracking-dialog :service-tracking="selectedRecord" :show="showEditServiceTrackingDialog" @close="closeEditServiceTracking"></edit-service-tracking-dialog>
      <delete-service-tracking-confirm-dialog :service-tracking="selectedRecord" :show="showDeleteServiceTrackingConfirmDialog" @close="closeDeleteServiceTracking"></delete-service-tracking-confirm-dialog>
      <approve-service-tracking-dialog :service-tracking="selectedRecord" :show="showApproveServiceTrackingDialog" @close="closeApproveServiceTracking"></approve-service-tracking-dialog>
    </v-flex>
    <div class="text-center button-center" >
      <v-btn
        fab
        color="secondary"
        dark
        bottom
        center
        @click="openNewServiceTracking"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
  import newServiceTrackingDialog from './NewServiceTrackingDialog'
  import EditServiceTrackingDialog from './EditServiceTrackingDialog'
  import DeleteServiceTrackingConfirmDialog from './DeleteServiceTrackingConfirmDialog'
  import ApproveServiceTrackingDialog from './ApproveServiceTrackingDialog'
export default {
    name: 'MyServiceTracking',
    components: {
      'new-tracking-dialog': newServiceTrackingDialog,
      'edit-service-tracking-dialog': EditServiceTrackingDialog,
      'delete-service-tracking-confirm-dialog': DeleteServiceTrackingConfirmDialog,
      'approve-service-tracking-dialog': ApproveServiceTrackingDialog
    },
    data () {
      return {
        page: 0,
        size: 20,
        bottom: false,
        showNewServiceTrackingDialog: false,
        showEditServiceTrackingDialog: false,
        showDeleteServiceTrackingConfirmDialog: false,
        showApproveServiceTrackingDialog: false,
        selectedRecord: {
          id: null,
          customer: null,
          service: null,
          date: null,
          startTime: null,
          finishTime: null,
          approved: false
        }
      }
    },
    watch: {
      bottom (bottom) {
        if (bottom) {
          this.page++
          this.loadMyServicesTrackings()
        }
      }
    },
    computed: {
      myTrackings: function () {
        return this.$store.getters.myServiceTrackings
      }
    },
    created () {
      this.$store.dispatch('loadUserData', this.$store.getters.user)
      this.resetTrackings()
    },
    methods: {
      loadMyServicesTrackings: function () {
        this.$store.dispatch('loadMyServicesTrackings',
          {
            page: this.page,
            size: this.size
          })
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      getDate: function (millis) {
        const date = new Date(millis)
        let dd = date.getDate()
        let mm = date.getMonth() + 1
        const yyyy = date.getFullYear()

        if (dd < 10) {
          dd = `0${dd}`
        }

        if (mm < 10) {
          mm = `0${mm}`
        }

        return `${dd}.${mm}.${yyyy}`
      },
      getTime: function (millis) {
        const date = new Date(millis)
        let mn = date.getMinutes()
        let hr = date.getHours()

        if (mn < 10) {
          mn = `0${mn}`
        }

        if (hr < 10) {
          hr = `0${hr}`
        }

        return `${hr}:${mn}`
      },
      getDay: function (millis) {
        const ms = new Date(millis)
        const msPerDay = 86400000
        let beginning = ms - (ms % msPerDay)
        beginning += ((new Date()).getTimezoneOffset() * 60 * 1000)
        return beginning
      },
      openNewServiceTracking: function () {
        this.showNewServiceTrackingDialog = true
      },
      closeNewServiceTracking: function () {
        this.showNewServiceTrackingDialog = false
      },
      openEditServiceTracking: function (record) {
        this.selectedRecord = this.getSelectedRecord(record)
        this.showEditServiceTrackingDialog = true
      },
      closeEditServiceTracking: function () {
        this.showEditServiceTrackingDialog = false
      },
      openDeleteServiceTracking: function (record) {
        this.selectedRecord = this.getSelectedRecord(record)
        this.showDeleteServiceTrackingConfirmDialog = true
      },
      closeDeleteServiceTracking: function () {
        this.showDeleteServiceTrackingConfirmDialog = false
        this.resetTrackings()
      },
      openApproveServiceTracking: function (record) {
        record.approved = true
        this.selectedRecord = this.getSelectedRecord(record)
        this.showApproveServiceTrackingDialog = true
      },
      getSelectedRecord: function (record) {
        return {
          id: record.id,
          user: record.user,
          customer: record.customer,
          service: record.service,
          date: this.getDay(record.startTime),
          startTime: this.getTime(record.startTime),
          finishTime: this.getTime(record.finishTime)
        }
      },
      closeApproveServiceTracking: function () {
        this.showApproveServiceTrackingDialog = false
        this.resetTrackings()
      },
      resetTrackings: function () {
        this.page = 0
        this.size = 20
        this.$store.dispatch('resetServiceTrackings')
        this.loadMyServicesTrackings()
      }
    }
  }
</script>

<style scoped>

div.button-center{
  position:fixed;
  bottom:0;
  width:100%;
  margin-top: 5px;
  margin-bottom: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/ServiceTracking/MyServiceTracking.vue